const colorsDefinition = {
    foreground: {
        default: '#193643',
        muted: '#466573',
        subtle: '#5F7D8B',
        disabled: '#B0C8D2',
        onEmphasis: '#FFFFFF',
    },
    background: {
        default: '#FFFFFF',
        subtle: '#F8FBFD',
        inset: '#F1F7FA',
        disabled: '#E2EFF5',
        muted: '#CEE2EA',
        emphasis: '#193643',
        dimming: '#19364333',
    },
    border: {
        default: '#B0C8D2',
        subtle: '#F1F7FA',
        muted: '#CEE2EA',
        emphasis: '#193643',
    },
    accent: {
        tint: '#002B80',
        foreground: '#0047D5',
        emphasis: '#0659FF',
        border: '#B8D8FF',
        background: '#EFF8FF',
    },
    positive: {
        tint: '#005118',
        foreground: '#008629',
        emphasis: '#00A131',
        border: '#97EAB0',
        background: '#E0FAE8',
    },
    attention: {
        tint: '#802800',
        foreground: '#D54200',
        emphasis: '#FF4F00',
        border: '#FFD4B5',
        background: '#FFF7EE',
    },
    negative: {
        tint: '#750B00',
        foreground: '#C21200',
        emphasis: '#E91B06',
        border: '#FFBAB1',
        background: '#FFEFEC',
    },
    special: {
        tint: '#33007F',
        foreground: '#5600D4',
        emphasis: '#6700FE',
        border: '#DDB5FF',
        background: '#F9EEFF',
    },
    effects: {
        // Specific UI treatment colors that do not belong to the semantic palettes.
        activityBackground: '#FCFCFD',
        accentGradientStop: '#3386FF',
        focus: '#0659FF80',
    },
} as const;

export const colors = colorsDefinition;

// Utility type to extract all possible color paths
type ColorPaths<T, K extends keyof T = keyof T> = K extends string
    ? T[K] extends Record<string, any>
        ? T[K] extends string
            ? K
            : `${K}.${ColorPaths<T[K]>}`
        : K
    : never;

export type ColorPath = ColorPaths<typeof colorsDefinition>;
